import { forwardRef } from 'react'
import { RigidBody, RigidBodyProps } from '@react-three/rapier'
import { RapierRigidBody } from '@react-three/rapier'
import { useGLTF } from '@react-three/drei'

interface BallProps extends Omit<RigidBodyProps, 'ref'> {}

export const Ball = forwardRef<RapierRigidBody, BallProps>((props, ref) => {
  const { scene } = useGLTF('/models/ball.glb')
  return (
    <RigidBody
      ref={ref}
      position={[0, 0.2, -11]} // Ball exactly on penalty spot, on ground
      restitution={0.01}
      friction={0.3}
      mass={1}
      colliders="ball"
      ccd={true}
      {...props}
    >
      {/* Use GLB model, scale to match collider radius */}
      <primitive object={scene} scale={0.15} />
    </RigidBody>
  )
})

// Required for GLTF loading
useGLTF.preload('/models/ball.glb') 